import React from "react";
import PageHeader from "../components/PageHeader";

export default function RteAct() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Acts & Guidelines", link: "/acts" },
    { label: "RTE Act", active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="RTE Act" breadcrumbs={breadcrumbs} />

      {/* Main Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="bg-white p-5 rounded-4 shadow-sm border-start border-4 border-primary">
                <h2 className="fw-bold text-primary text-center mb-3">
                  RTE Act (NCPCR, Govt. of India)
                </h2>
                <p className="text-secondary text-center mb-4">
                  Right of Children to Free and Compulsory Education Act, 2009
                </p>

                <ul className="list-unstyled ps-3" style={{ lineHeight: "1.8" }}>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    Examine and review the safeguards for rights provided by or
                    under this act and recommend measures for their effective
                    implementation;
                  </li>
                  <li>
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    Inquire into complaints relating to child's right to free
                    and compulsory education.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
